import { Flex, Icon, Text, Tooltip } from "@chakra-ui/react"
import { Route } from "configuration"
import { useSidebarContext } from "context/sidebarContext"
import { FC } from "react"
import { FiCircle, FiLock } from "react-icons/fi"
import { Link as RouterLink, useLocation } from "react-router-dom"

interface SidebarItemBtnProps {
  route: Route
  // Нет доступа у клиента: пункт виден, но не нажимается
  isLocked?: boolean
}

export const SidebarItemBtn: FC<SidebarItemBtnProps> = (props) => {
  const { route, isLocked = false } = props

  const { isCollapsed } = useSidebarContext()
  const { pathname } = useLocation()

  // Заблокирован для клиента или для всех (isDisabled, нет страницы)
  const isInactive = isLocked || route.isDisabled || !route.url
  const path = `/${route.url}`
  const isOnPage = (url: string) =>
    pathname === `/${url}` || pathname.startsWith(`/${url}/`)
  // Подсвечиваем и вложенные страницы, и адреса из matchUrls
  const isActive = !isInactive && [route.url!, ...(route.matchUrls || [])].some(isOnPage)

  const tooltip = isInactive ? `${route.title} · нет доступа` : route.title

  const item = (
    <Flex
      {...(isInactive ? {} : { as: RouterLink, to: path })}
      w="full"
      minH={9}
      py={1.5}
      flexShrink={0}
      alignItems="center"
      justifyContent={isCollapsed ? "center" : "flex-start"}
      gap={3}
      px={isCollapsed ? 0 : 3}
      borderRadius="md"
      fontSize="sm"
      fontWeight="medium"
      color={isActive ? "purple.700" : isInactive ? "gray.400" : "gray.700"}
      bg={isActive ? "purple.100" : "transparent"}
      cursor={isInactive ? "not-allowed" : "pointer"}
      transition="background 0.15s ease"
      _hover={isInactive || isActive ? {} : { bg: "gray.100" }}
    >
      <Icon
        as={route.icon || FiCircle}
        boxSize={4}
        flexShrink={0}
        color={isActive ? "purple.600" : isInactive ? "gray.300" : "gray.500"}
      />

      {!isCollapsed && (
        <>
          {/* Длинное название переносится, а не обрезается многоточием */}
          <Text flex={1} noOfLines={2} lineHeight="short">
            {route.title}
          </Text>

          {isInactive && (
            <Icon as={FiLock} boxSize={3.5} flexShrink={0} color="gray.400" />
          )}
        </>
      )}
    </Flex>
  )

  // В свёрнутой панели видны только иконки — название в подсказке. У
  // заблокированных подсказка и в развёрнутой: объясняет, почему не нажимается
  return (
    <Tooltip
      label={tooltip}
      placement="right"
      isDisabled={!isCollapsed && !isInactive}
      openDelay={isInactive ? 300 : 0}
      hasArrow
    >
      {item}
    </Tooltip>
  )
}
